export default "__VITE_ASSET__Mi46cRXd__"